import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";
import { setReplayUserId } from "@/plugins/sessionReplay";

export default createStore({
  state: {
    accessToken: "",
    staffInfo: {
      idx: 0,
      email: "",
      kname: "",
      ename: "",
      idxTeam: 0,
      idxOffice: 0,
      inOffice: "",
    },
    searchParams: {},
  },
  getters: {
    getAccessToken(state) {
      console.log("getAccessToken", state);
      setReplayUserId(state.staffInfo.email);
      return state.accessToken;
    },
  },
  mutations: {
    setAccessToken(state, userInfo) {
      state.accessToken = userInfo.accessToken;
      state.staffInfo = userInfo.staffInfo;
      console.log("setAccessToken", userInfo);
      setReplayUserId(userInfo.staffInfo.email);
    },
  },
  actions: {},
  plugins: [
    createPersistedState({
      key: "LifeEduAdminVuex",
    }),
  ],
});
